import { Ref, unref } from '@nuxtjs/composition-api';
import { Route } from 'vue-router';

export const isPromotionsRoute = (routeArg: Ref<Route> | Route) => {
  const route = unref(routeArg);
  return route.path.startsWith(`/promotions`);
};
